import { render, staticRenderFns } from "./iluminacao_v1.vue?vue&type=template&id=cb62b36a"
import script from "./iluminacao_v1.vue?vue&type=script&lang=js"
export * from "./iluminacao_v1.vue?vue&type=script&lang=js"
import style0 from "./iluminacao_v1.vue?vue&type=style&index=0&id=cb62b36a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports